import { getAllCarSeriesApi } from '~/server'

export default defineStore('carSeries', () => {
  const carSeries = reactive<Map<string, string>>(new Map())

  async function getAllSeries() {
    const { data } = await getAllCarSeriesApi()

    const arg = /[0-9a-zA-Z\s-_.]{6}/
    const argZh = /[\u4E00-\u9FA5]{1}/
    data.forEach((i) => {
      if (
        (i.carSeriesName.match(argZh) && i.carSeriesName.length > 3)
        || i.carSeriesName.match(arg)
      ) {
        carSeries.set(i.carSeriesName, i.id)
        carSeries.set(i.carBrandName.replace('新能源', '').replace('汽车', '') + i.carSeriesName, i.id)
      }
      else { carSeries.set(i.carBrandName.replace('新能源', '').replace('汽车', '') + i.carSeriesName, i.id) }
    })
  }

  async function formatContent(content: string) {
    if (!carSeries.size)
      await getAllSeries()

    let seriesList: string[] = []
    carSeries.forEach((value, key) => {
      content?.indexOf(key) >= 0 && seriesList?.push(key)
    })

    seriesList = [...new Set(seriesList)].sort((a, b) => b.length - a.length)

    seriesList.forEach((i) => {
      content = content?.replaceAll(new RegExp(i, 'gi'), (e, index, str2) => {
        const longNames = seriesList.filter(j => j.includes(i) && i !== j)

        if (patternIsTagAttribute(str2, index))
          return e
        for (const longName of longNames) {
          const startIndex = longName.indexOf(i)

          const startStr = str2.charAt(index - startIndex - 1)
          const endStr = str2.charAt(index - startIndex + longName.length)

          if (startStr === '>' && endStr === '<')
            return e
        }

        return `<a class="seriesName" target="_blank" href="/reputation/${carSeries.get(e)}">${e}</a>`
      })
    })

    return content
  }

  // 判读是否在标签中<div alt="xxxx">???</div>
  function patternIsTagAttribute(content: string, index: number): boolean {
    let leftIndex = -1
    let rightIndex = -1
    for (let i = index; i >= 0; i--) {
      if (content[i] === '<') {
        leftIndex = i
        break
      }
      else if (content[i] === '>') {
        break
      }
    }
    for (let i = index; i < content.length; i++) {
      if (content[i] === '>') {
        rightIndex = i
        break
      }
      else if (content[i] === '<') {
        break
      }
    }

    return leftIndex !== -1 && rightIndex !== -1
  }

  return { carSeries, getAllSeries, formatContent }
})
